<template>
  <section>
    <div
      v-for="(member, index) in teamMembers"
      :key="index"
      class="profile-card"
    >
      <div class="profile-img profile-img--placeholder" aria-hidden="true">
        {{ member.initial }}
      </div>
      <h2 class="profile-name">{{ member.name }}</h2>
      <p class="profile-role">{{ member.role }}</p>

      <div class="social-icons">
        <a href="#"><i class="fa-brands fa-twitter"></i></a>
        <a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
        <a href="#"><i class="fa-brands fa-github"></i></a>
      </div>

      <div class="action-buttons">
        <button class="message-btn">Message</button>
        <button class="update-btn">Update User</button>
        <button class="delete-btn">Delete User</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TeamMembers",
  data() {
    return {
      teamMembers: [
        {
          name: "Bango",
          role: "Chief Executive Officer",
          initial: "B",
        },
        {
          name: "Brian Davis",
          role: "Support",
          initial: "B",
        },
        {
          name: "Alex Scott",
          role: "Software Engineer",
          initial: "A",
        },
        {
          name: "Rose Christine",
          role: "Finance",
          initial: "R",
        },
      ],
    };
  },
};
</script>

<style scoped>
section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  background-color: var(--background-color1);
  padding: 1rem;
}

/* Card */
.profile-card {
  background: var(--background-color2);
  border-radius: 12px;
  padding: 1.5rem 1rem;
  text-align: center;
  flex: 1 1 260px;
  max-width: 280px;
  box-shadow: 0 6px 16px var(--box-shadow);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.profile-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

/* Profile image */
.profile-img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid aqua;
  margin-bottom: 0.8rem;
}

.profile-img--placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-inline: auto;
  background: var(--background-color1);
  color: var(--text-color1);
  font-size: 1.75rem;
  font-weight: 700;
}

/* Texts */
.profile-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-color1);
  margin-bottom: 0.3rem;
}

.profile-role {
  font-size: 0.75rem;
  color: var(--text-color2);
  margin-bottom: 0.8rem;
}

/* Social Icons */
.social-icons {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 0.8rem;
}

.social-icons a {
  color: var(--text-color1);
  font-size: 0.9rem;
  transition: color 0.3s ease, transform 0.2s ease;
}

.social-icons a:hover {
  color: aqua;
  transform: scale(1.1);
}

/* Buttons */
.action-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

button {
  border: none;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 0.7rem;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

/* Button colors */
.message-btn {
  background: #007bff;
  color: white;
}

.update-btn {
  background: #28a745;
  color: white;
}

.delete-btn {
  background: #dc3545;
  color: white;
}

/* Hover effects */
button:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

/* Responsive layout */
@media (max-width: 768px) {
  section {
    flex-direction: column;
    align-items: center;
  }

  .profile-card {
    width: 90%;
    max-width: 320px;
  }

  .profile-name {
    font-size: 0.85rem;
  }

  .profile-role {
    font-size: 0.7rem;
  }

  button {
    font-size: 0.65rem;
    padding: 6px 10px;
  }
}
</style>
